import { Trans } from '@lingui/macro';
import React, { Fragment } from 'react';
import { ProjectAdminSubContainerStyled } from '../../styled';

const WorkPackageCard = () => {
  return (
    <Fragment>
      <ProjectAdminSubContainerStyled>
        <Trans>WorkPackage Card Design</Trans>
      </ProjectAdminSubContainerStyled>
    </Fragment>
  );
};

export default WorkPackageCard;
